<template>
    <div v-if="!isPortrait" class="footer">
        <div class="logo">
        <img class="logo-image" src="../assets/mm-white-logo-en.png">
        </div>

        <div v-if="serverTimeDiff" class="date-time">
            <div class="date">
                {{getActualDate()}}
            </div>

            <div class="time">
                <clock :timeDiff="serverTimeDiff"></clock>
            </div>
        </div>
    </div>

    <div v-else class="footer-portrait">
        <img class="logo-image" src="../assets/Mendelu_symbol_rgb_white.png">
        <div v-if="serverTimeDiff" class="date-portrait">
          {{getActualDatePortrait()}}
        </div>
        <div v-if="serverTimeDiff" class="time-portrait">
          <clock :timeDiff="serverTimeDiff"></clock>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import Clock from "./Clock";

    export default {
        name: "Footer",

        props: {
            serverTime: Number,
        },

        components: {
            Clock
        },

        data() {
            return {
                windowWidth: window.innerWidth,
                windowHeight: window.innerHeight
            }
        },

        mounted() {
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
                this.windowHeight = window.innerHeight;
            })
        },

        methods: {
            getActualDate() {
                return moment(Date.now() - this.serverTimeDiff).locale("cs").format("dddd, D. MMMM YYYY").toLowerCase();
            },
            getActualDatePortrait(){
                return moment(Date.now() - this.serverTimeDiff).locale("cs").format("D. M.").toLowerCase();
            }
        },

        computed: {
            serverTimeDiff() {
                return Date.now() - this.serverTime;
            },
            isPortrait() {
              return this.windowHeight > this.windowWidth
            }
        },
    }
</script>

<style scoped>
    .footer {
        height: 7vh;
        width: 100vw;
        background-color: #090909;
        font-weight: bold;
        color: white;
        font-size: 3.4vh;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        font-family: 'Roadgeek';
        border-top: 0.25vh solid #353535;
        position: relative;
        z-index: 2;
    }

    .footer-portrait {
      width: 100%;
      height: 7vh;
      background-color: #090909;
      font-weight: bold;
      color: white;
      font-size: 3.4vh;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-family: 'Roadgeek';
      border-top: 0.25vh solid #353535;
      position: relative;
      z-index: 2;
    }

    .logo {
        float: left;
        max-height: 7vh;
    }

    .logo-image {
        height: 7vh;
        margin: 0 1.5vw 0.25vh 0.1vw;
        object-fit: contain;
    }

    .date-time {
        float: right;
        margin: 0.9vh 1vw 0.25vh 1vw;
        display: flex;
        flex-wrap: nowrap;
    }

    .time {
        display: inline-block;
        min-width: max(19vh, 6.5vw);
    }

    .date {
        display: inline-block;
        margin-right: 6vw;
    }

    .date-portrait {
      display: inline-block;
      white-space: nowrap;
    }

    .time-portrait {
      display: inline-block;
      white-space: nowrap;
      width: 30%;
    }

</style>
